export type PageItem = number | '…';

/** 1 2 3 … 50, with the current page and its neighbors. */
export function pageList(page: number, totalPages: number): PageItem[] {
  const total = Math.max(1, totalPages);
  const current = Math.min(Math.max(1, page), total);
  const wanted = new Set<number>([1, total, current - 2, current - 1, current, current + 1, current + 2]);
  const pages = [...wanted].filter((value) => value >= 1 && value <= total).sort((a, b) => a - b);
  const items: PageItem[] = [];
  for (const value of pages) {
    const previous = items[items.length - 1];
    if (typeof previous === 'number' && value - previous > 1) items.push('…');
    items.push(value);
  }
  return items;
}
